import request from '@/utils/request'

// 短信账户列表
export const getSmsAccountList = (params: any) =>
  request({
    url: 'manage/sms-account',
    method: 'get',
    params
  })

// 创建短信账户
export const createSmsAccount = (data: any) =>
  request({
    url: 'manage/sms-account',
    method: 'post',
    data
  })

// 编辑短信账户
export const editSmsAccount = (data: any) =>
  request({
    url: `manage/sms-account/${data.id}`,
    method: 'patch',
    data
  })

// 刷新余额
export const refreshBalance = (data: any) =>
  request({
    url: `manage/sms-account/${data.id}`,
    method: 'patch',
    data
  })

// 删除短信账户
export const deleteSmsAccount = (data: any) =>
  request({
    url: `manage/sms-account/${data.id}`,
    method: 'delete',
    data
  })

// 短信商户余额列表
export const getSmsAccountBalanceList = (params: any) =>
  request({
    url: 'manage/sms-merchant',
    method: 'get',
    params
  })

// 账户余额列表
export const getSmsAccountBalance = (params: any) =>
  request({
    url: `manage/sms-merchant-balance-bill/${params.id}`,
    method: 'get',
    params
  })

// 添加余额
export const addSmsAccountBalance = (data: any) =>
  request({
    url: `manage/sms-merchant-balance-detail/${data.id}`,
    method: 'patch',
    data
  })

// 短信记录列表
export const getSmsRecordList = (params: any) =>
  request({
    url: `manage/sms-account-bill`,
    method: 'get',
    params
  })

// 短信开关编辑
export const editSmsSwitch = (data: any) =>
  request({
    url: `manage/sms-merchant-balance-detail/${data.id}`,
    method: 'post',
    data
  })
